export const onlyDigits = (value?: string | null): string => (value || '').replace(/\D/g, '');

export const formatCpf = (cpf?: string | null): string => {
    const digits = onlyDigits(cpf);
    if (digits.length !== 11) return cpf || '';
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

// Máscara progressiva (00) 0000-0000 / (00) 00000-0000 — serve tanto para exibir quanto
// para o input do celular enquanto o parceiro digita.
export const formatPhone = (phone?: string | null): string => {
    const digits = onlyDigits(phone).slice(0, 11);
    if (!digits) return '';
    if (digits.length <= 2) return `(${digits}`;
    const ddd = digits.slice(0, 2);
    const rest = digits.slice(2);
    if (rest.length <= 4) return `(${ddd}) ${rest}`;
    const split = rest.length === 9 ? 5 : 4;
    return `(${ddd}) ${rest.slice(0, split)}-${rest.slice(split)}`;
};

// Datas da API vêm em ISO (YYYY-MM-DD ou YYYY-MM-DDTHH:MM:SS). Lidas por regex para não
// passar por Date e escorregar um dia por fuso.
export const formatIsoDate = (value?: string | null): string => {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
    return match ? `${match[3]}/${match[2]}/${match[1]}` : '';
};

export const isoDateOnly = (value?: string | null): string => {
    const match = /^(\d{4}-\d{2}-\d{2})/.exec(value || '');
    return match ? match[1] : '';
};

export const todayIso = (): string => {
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};
